/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResultCode } from '../../models/result-code';

export interface DeleteResultCodes$Params {
  resultCodeGuid: string;
}

export function deleteResultCodes(http: HttpClient, rootUrl: string, params: DeleteResultCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultCode>> {
  const rb = new RequestBuilder(rootUrl, deleteResultCodes.PATH, 'delete');
  if (params) {
    rb.query('resultCodeGuid', params.resultCodeGuid, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResultCode>;
    })
  );
}

deleteResultCodes.PATH = '/resultcodes';
